import { Button, DropdownMenu, Skeleton, lucideIcons, tableHelpers } from '@round/creatorbase-ui';
import { CellContext } from 'Modules/Plans/CreatorSearch/components/CreatorExploreTable/helpers';
import { getTableMeta } from '../../helpers';
import styles from './ActionsCell.module.css';

const { EllipsisVertical, Trash2 } = lucideIcons;

export const ActionsCell = ({ row: { original }, table }: CellContext) => {
    const { isLoading, onRemoveCreators } = getTableMeta(table);

    if (tableHelpers.isLoadingRow(original) || isLoading) {
        return <Skeleton className={styles.skeleton} />;
    }

    return (
        <DropdownMenu>
            <DropdownMenu.Trigger asChild>
                <Button type="button" variant="ghost" size="icon-sm" aria-label="Actions">
                    <EllipsisVertical />
                </Button>
            </DropdownMenu.Trigger>
            <DropdownMenu.Content align="end">
                <DropdownMenu.Item variant="destructive" onSelect={() => onRemoveCreators([original])}>
                    <Trash2 />
                    Remove
                </DropdownMenu.Item>
            </DropdownMenu.Content>
        </DropdownMenu>
    );
};
